import {
  DELETE_FOLLOWER,
  DELETE_FOLLOWER_FAILED,
  GET_FOLLOWERS,
  GET_FOLLOWINGS,
  SUBSCRIBE,
  SUBSCRIBE_FAILED,
} from '../constants/index';
import {
  GetFollowersType,
  SubscribePayloadType,
  deleteFollowerSuccess,
  getFollowersFailed,
  getFollowersSuccess,
  getFollowingsFailed,
  getFollowingsSuccess,
  subscribeSuccess,
} from '../actions/followersActions';
import { RootState, SubscriberType } from 'types/stateTypes';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from '../actions/themeActions';
import { ErrorResponseType } from 'types/reduxTypes';
import { cls } from 'constants/cls';
import config from 'shared/config';
import safeAxios from 'shared/api/safeFetch';

function* subscribeHandler({
  payload: { userId, subscribed, blocked, fullName, imageUrl },
}: ActionType<SubscribePayloadType>) {
  const {
    foreignUser: {
      userInfo: { id },
    },
    user: { userInfo },
  }: RootState = yield select();
  const isForeignProfile = userId === id;
  try {
    const user = {
      blocked,
      fullName,
      imageUrl,
      rEntity: `${cls.user}:${userId}`,
      subscribed: !subscribed,
    };
    yield call(safeAxios, `${config.apiUrl}/user_subscription`, {
      body: [user],
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
    });
    const successBody = isForeignProfile
      ? {
          fullName: userInfo.fullName,
          imageUrl: userInfo.imageUrl,
          isForeignProfile,
          rEntity: userInfo.uref,
          subscribed: !subscribed,
          userId: userInfo.id,
        }
      : { ...user, isForeignProfile, userId };
    yield put(subscribeSuccess(successBody));
  } catch (error: unknown) {
    const err = error as ErrorResponseType;
    const message = err.response || err.message;
    yield put({
      payload: { message },
      type: SUBSCRIBE_FAILED,
    });
  }
}

function* getFollowingsHandler({ payload: { userId, page = 1, pageSize = 20 } }: ActionType<GetFollowersType>) {
  try {
    const { data } = yield call(
      safeAxios,
      `${config.apiUrl}/user_subscription/${userId}?pageSize=${pageSize}&page=${page}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }
    );
    yield put(
      getFollowingsSuccess({
        items: data as unknown as SubscriberType[],
        page,
        pageSize,
      })
    );
  } catch (error: unknown) {
    const err = error as ErrorResponseType;
    const message = (err.response && err.response.status) || err.message || 'getFollowingsError';
    yield put(getFollowingsFailed({ message: message as unknown as string }));
  }
}

function* getFollowersHandler({ payload: { userId, page = 1, pageSize = 20 } }: ActionType<GetFollowersType>) {
  try {
    const { data } = yield call(safeAxios, `${config.apiUrl}/user_subscription/subscribers/${cls.user}:${userId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    yield put(
      getFollowersSuccess({
        items: data as unknown as SubscriberType[],
        page,
        pageSize,
      })
    );
  } catch (error: unknown) {
    const err = error as ErrorResponseType;
    const message = (err.response && err.response.status) || err.message || 'getFollowersError';
    yield put(getFollowersFailed({ message: message as unknown as string }));
  }
}

function* deleteFollowerHandler({ payload: user }: ActionType<SubscribePayloadType>) {
  try {
    yield call(safeAxios, `${config.apiUrl}/user_subscription/subscribers/self/${cls.user}:${user.userId}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    });
    yield put(deleteFollowerSuccess(user));
  } catch (error: unknown) {
    const err = error as ErrorResponseType;
    const message = err.response || err.message;
    yield put({
      payload: { message },
      type: DELETE_FOLLOWER_FAILED,
    });
  }
}

export default function* fetchProfileWatcher(): Generator {
  yield takeEvery(GET_FOLLOWINGS, getFollowingsHandler);
  yield takeEvery(GET_FOLLOWERS, getFollowersHandler);
  yield takeEvery(DELETE_FOLLOWER, deleteFollowerHandler);
  yield takeEvery(SUBSCRIBE, subscribeHandler);
}
